(function(EnumUtils) {
    function loopEnums(targetEnum, block) {
        for(const element in targetEnum){
            const elementNo = Number(element);
            if (!isNaN(elementNo)) {
                block(element, elementNo);
            }
        }
    }
    // Only works with numeric enums
    EnumUtils.loopEnums = loopEnums;
    function iterateEnum(targetEnum, callback) {
        for(const enumValue in targetEnum){
            if (isNaN(Number(enumValue))) {
                callback(targetEnum[enumValue]);
            }
        }
    }
    // Works with both numeric and string enums
    EnumUtils.iterateEnum = iterateEnum;
    function getLength(targetEnum) {
        const enumKeys = Object.keys(targetEnum);
        return enumKeys.filter((key)=>isNaN(Number(key))).length;
    }
    EnumUtils.getLength = getLength;
    function getEnumKey(enumValue, enumType) {
        return enumType[enumValue];
    }
    EnumUtils.getEnumKey = getEnumKey;
    function getEnumValue(enumKeyOrValue, enumType) {
        if (enumKeyOrValue == undefined) return undefined;
        if (!isNaN(Number(enumKeyOrValue))) return enumType[Number(enumKeyOrValue)] !== undefined ? Number(enumKeyOrValue) : undefined;
        return enumType[enumKeyOrValue];
    }
    EnumUtils.getEnumValue = getEnumValue;
    function getEnumKeys(enumType) {
        return Object.keys(enumType).filter((key)=>isNaN(Number(key)));
    }
    EnumUtils.getEnumKeys = getEnumKeys;
    function getEnumValues(enumType) {
        return Object.keys(enumType).filter((key)=>isNaN(Number(key))).map((key)=>enumType[key]);
    }
    EnumUtils.getEnumValues = getEnumValues;
})(EnumUtils || (EnumUtils = {}));
export var EnumUtils;
